export default __webpack_public_path__ + "static/media/gmailSvg.77690df5.svg";